module.exports = __webpack_public_path__ + "static/img/rank_348.d16162a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_348.png
// module id = Nlm+
// module chunks = 0